(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("esatisfaction", TrackingModel);

        if (!Tracker) {
            return;
        }

        var CanTrack = LhApp.Function.Tracking.canTrack('statisticCookies');

        Init();

        function Init() {
            if (!CanTrack) return;

            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var trackOrder = {
                    "email": TrackingModel.Order.CustomerEmail,
                    "phone": TrackingModel.Order.CustomerMobiles,
                    "transaction_id": TrackingModel.Order.Id,
                    "transaction_date": TrackingModel.Order.CompletedDateTime,
                    "store_pickup": TrackingModel.Order.IsStorePickup ? 1 : 0,
                    "store_id": TrackingModel.Order.IsStorePickup ? TrackingModel.Order.StoreCode : "",
                    "event": "esat_purchase"
                };

                dataLayer.push(trackOrder);
            }
        }
    });
})();